module.exports = __webpack_public_path__ + "static/media/Image_Microsite_Consoles_ST.1b581871.png";